export interface BootstrapAuthState<TUser> {
  user: TUser | null;
  isAuthenticated: boolean;
  canSkipLoading: boolean;
}

export const buildBootstrapAuthState = <TUser>({
  cachedUser,
  hasSessionMarker,
}: {
  cachedUser: TUser | null;
  hasSessionMarker: boolean;
}): BootstrapAuthState<TUser> => {
  const canSkipLoading = Boolean(cachedUser && hasSessionMarker);

  return {
    user: canSkipLoading ? cachedUser : null,
    isAuthenticated: canSkipLoading,
    canSkipLoading,
  };
};

export const shouldClearBootstrapSession = ({
  hasValidSession,
  bootstrapCanSkipLoading,
}: {
  hasValidSession: boolean;
  bootstrapCanSkipLoading: boolean;
}) => !hasValidSession && bootstrapCanSkipLoading;
